// test374
(374 && 0);
